import { render, staticRenderFns } from "./BqFilterColumns.vue?vue&type=template&id=0ba7c2de&scoped=true&"
import script from "./BqFilterColumns.vue?vue&type=script&lang=js&"
export * from "./BqFilterColumns.vue?vue&type=script&lang=js&"
import style0 from "./BqFilterColumns.vue?vue&type=style&index=0&id=0ba7c2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba7c2de",
  null
  
)

export default component.exports